import React, { useState, useEffect } from 'react';
import secureStorage from "../../config/encrypt";
import SkuTransactionList from './SkuTransactionList';
import SkuTransactionFilters from './SkuTransactionsFilters';
import DealerService from '../../service/DealerService';

const SkuTransactionPannel = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [transactionList, setTransactionList] = useState([]);
    const [filters, setFilters] = useState({
        search_by: null,
        search_value: '',
        search: '',
        skuName: null,
        city: null,
        package_status: null,
        payment_status: null,
        xendit_status: null,
    });
    const [appliedFilters, setAppliedFilters] = useState(filters);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
    });
    const [hasMoreItems, setHasMoreItems] = useState(true);
    const loginResponse = secureStorage.getItem('loginUserInfo');
    const userData = loginResponse && loginResponse.data && loginResponse.data.user_data || {};
    const dealerData = loginResponse && loginResponse.data && loginResponse?.data?.dealer_data || {};
    const roleData = loginResponse.data.user_data.role_data || [];
    const role_access = loginResponse && loginResponse.data && loginResponse.data.user_data && loginResponse.data.user_data.role_data && loginResponse.data.user_data.role_data.length > 0 ? loginResponse.data.user_data.role_data : []
    const userId = userData?.user_id || 0;
    const dealerIDHash = dealerData[0]?.dealer_id_hash || '';
    const dealerId = dealerData[0]?.dealer_id;
    const userRole = userData && userData?.role;
    const isAdmin = userRole === 'admin';;

    useEffect(() => {
        fetchTransactionList(true);
    }, [appliedFilters]);

    useEffect(() => {
        fetchTransactionList();
    }, [pagination.page]);

    const fetchTransactionList = async () => {
        // remove null, undefined, or empty string values
        setIsLoading(true);
        const cleanedFilters = Object.fromEntries(
            Object.entries(filters).filter(([_, v]) => v !== null && v !== undefined && v !== '')
        );

        const payload = {
            page: pagination.page,
            limit: pagination.limit,
            ...cleanedFilters,
        };
        // Role-based conditions
        if (userRole === "dealercentral") {
            payload.isAdmin = false;
            payload.dealer_id = dealerId || userId;
        } else if (userRole === "admin") {
            payload.isAdmin = true;
        }

        const listResponse = await DealerService.getSkuTransactionList(payload);
        setIsLoading(false);

        if (
            listResponse &&
            listResponse?.status === 200 &&
            listResponse?.data?.status === 200
        ) {
            const dataResponse = listResponse.data.data;
            const list = dataResponse?.data || [];
            const paginationDetails = dataResponse?.pagination || {};

            const updatedList = payload.page === 1 ? list : [...transactionList, ...list];

            setTransactionList(updatedList);
            setPagination((prev) => ({
                ...prev,
                total: paginationDetails?.total || 0,
            }));
            setHasMoreItems(paginationDetails?.next_page);
        }
    };

    // handle filter change
    const handleFilterChange = (field, value) => {
        let v;

        if (['package_status', 'search_by', 'payment_status', 'xendit_status'].includes(field)) {
            v = value?.value;
        } else {
            v = value;
        }

        setFilters((prev) => ({
            ...prev,
            [field]: v,
        }));
        setPagination((prev) => ({ ...prev, page: 1 })); // reset to page 1
    };

    // reset filters
    const handleResetFilters = () => {
        let reset = {
            search_by: null,
            search_value: '',
            search: '',
            skuName: null,
            city: null,
            package_status: null,
        };
        setFilters(reset);
        setAppliedFilters(reset);
        setPagination((prev) => ({ ...prev, page: 1 }));
    };

    const handleApplyFilters = () => {
        setAppliedFilters(filters);
        setPagination((prev) => ({ ...prev, page: 1 }));
    };

    const loadMoreItems = () => {
        setPagination(prev => ({
            ...prev,
            page: prev.page + 1,
        }));
    };
    
    return (
        <>
            {/* <div className="container-fluid new-theme"> */}
            <div className={isLoading.loading ? "container-fluid new-theme loading" : "container-fluid new-theme"}>
                <div className="m-md-l m-md-r">
                    <h1>Transactions</h1>
                    <div className="dealer-card filter-form">
                        <SkuTransactionFilters
                            filters={filters}
                            onFilterChange={handleFilterChange}
                            onReset={handleResetFilters}
                            fetchTransactionList={fetchTransactionList}
                            handleApplyFilters={handleApplyFilters}
                            isAdmin={isAdmin}
                        />
                    </div>
                </div>
            </div>
            <SkuTransactionList 
                transactionList={transactionList}
                loadMoreItems={loadMoreItems}
                hasMoreItems={hasMoreItems}
                isLoading={isLoading}
                userRole={userRole}
            />
        </>
    );
};

export default SkuTransactionPannel;
